import * as React from 'react';
import {Entity} from 'draft-js';
import {ENTITY_TYPE} from 'draft-js-utils';

type EntityRangeCallback = (start: number, end: number) => void;

function Link(props_) {
  const {url} = Entity.get(props_.entityKey).getData();
  return (
    <a href={url}>{props_.children}</a>
);
}

function findLinkEntities(contentBlock, callback: EntityRangeCallback) {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey != null &&
      Entity.get(entityKey).getType() === ENTITY_TYPE.LINK
    );
  }, callback);
}

export default {
  strategy: findLinkEntities,
  component: Link
};



// WEBPACK FOOTER //
// ./src/components/form/RichEditor/decorators/LinkDecorator.tsx